import { Injectable } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { getDefaultControlValue } from '@gk/gk-modules';
import { BaseNewRequestFormService } from '../../../../shared/base-new-request-form/base-new-request-form.service';
import { DocumentationFormType } from '../../../../shared/base-new-request/base-new-request.model';
import {
  PLDACPSDNewRequestControlName,
  PLDACPSDNewRequestFormGroup,
} from './new-request-form.model';

@Injectable()
export class PLDACPSDNewRequestFormService {
  constructor(
    private formBuilder: UntypedFormBuilder,
    private baseNewRequestFormService: BaseNewRequestFormService,
  ) {}

  getFormGroup(): FormGroup<PLDACPSDNewRequestFormGroup> {
    return this.formBuilder.group({
      ...this.baseNewRequestFormService.getCommonApplicantFormGroup(
        {
          [PLDACPSDNewRequestControlName.ContactData]: true,
        },
        {
          documentationFormType: DocumentationFormType.NonElectronicForm,
        },
      ).controls,
      [PLDACPSDNewRequestControlName.ConstructionIntentionType]: [
        [],
        [Validators.required],
      ],
      [PLDACPSDNewRequestControlName.ConstructionProjectName]: [
        getDefaultControlValue(),
        [Validators.required],
      ],
    });
  }
}
